import React, { useState } from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter, Modal } from 'reactstrap';

const GenericConfirmModal = (props) => {
  const [modal, setModal] = useState(props.isOpen);
  const toggle = () => {
    setModal(!modal);
    if (props.cancelCallback) {
      props.cancelCallback();
    }
  };
  const remove = () => {
    props.onRequestClose();
  };
  const callback = () => {
    props.callback();
    toggle();
  };
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      onClosed={remove}
      style={{
        color: '#ffffff',
        maxWidth: '385px',
        margin: '1.75rem auto',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
        border: 'none',
        outline: 'none'
      }}
      contentClassName="delete-confirm-modal"
    >
      <ModalHeader 
        toggle={toggle}
        style={{
          backgroundColor: 'var(--chatbot-color-2)',
          color: '#ffffff',
          padding: '1rem 1.5rem',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          fontSize: '1.25rem',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
        close={
          <button
            className="close"
            onClick={toggle}
            style={{
              color: 'var(--accent-1-color)',
              opacity: 1,
              textShadow: 'none',
              background: 'none',
              border: 'none',
              fontSize: '1.75rem',
              fontWeight: 'normal',
              padding: '0.25rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: 'auto'
            }}
          >
            ×
          </button>
        }
      >
        <span style={{ color: '#fff' }}>{props.title}</span>
      </ModalHeader>
      <ModalBody style={{
        backgroundColor: 'var(--chatbot-color-1)',
        color: '#ffffff',
        padding: '1.5rem',
        fontSize: '1rem',
        lineHeight: '1.5'
      }}>
        <div style={{ color: '#ffffff' }}>{props.body}</div>
      </ModalBody>
      <ModalFooter style={{
        backgroundColor: 'var(--chatbot-color-2)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '1rem 1.5rem',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem'
      }}>
        <Button
          className="ml-auto btn-info-custom"
          onClick={callback}
          disabled={props.disableConfirm}
          style={props.disableConfirm ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        >
          <span style={{ position: 'relative', zIndex: 2 }}>Continue</span>
        </Button>
        <Button
          className="btn-danger-custom"
          onClick={toggle}
        >
          <span style={{ position: 'relative', zIndex: 2 }}>Cancel</span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GenericConfirmModal;
